<template>
  <div class="host-camera">
    <!-- <h4 class="camera-title">Oda sahibi Kamerası</h4> -->

    <div class="camera-container">
      <!-- <div v-if="hasHost" class="camera-feed"> -->
      <div class="camera-placeholder">
        <!-- <i class="fas fa-user-tie camera-icon"></i>
          <p class="camera-text">Host User</p>
          <p class="camera-subtext">Connected</p> -->
        <!-- <video autoplay playsinline ref="vp" /> -->
        <slot name="video" />
      </div>

      <div class="host-info">
        <span class="host-name">{{ hostName }}</span>
        <span class="connection-status" :class="{ online: hostOnline }">
          <i class="fas fa-circle"></i>
          {{ hostOnline ? "Online" : "Offline" }}
        </span>
      </div>
    </div>

    <!-- <div v-else class="no-host">
        <i class="fas fa-user-slash disconnect-icon"></i>
        <p class="disconnect-text">Oda sahibi bağlantısı kesildi</p>
        <p class="reconnect-text">Oda sahibi'ni bekliyor...</p>
      </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "HostCamera",
  props: {
    hostOnline: {
      type: Boolean,
      default: false,
    },
    hostName: {
      type: String,
      default: "Host User",
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.host-camera {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.camera-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.camera-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.camera-feed {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.camera-placeholder {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #000;
  border-radius: 8px;
  color: white;
  min-height: 120px;
  margin-bottom: 8px;
}

.camera-icon {
  font-size: 32px;
  margin-bottom: 8px;
  opacity: 0.7;
  color: #dc3545;
}

.camera-text {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

.camera-subtext {
  margin: 4px 0 0 0;
  font-size: 12px;
  opacity: 0.7;
}

.host-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-size: 12px;
}

.host-name {
  font-weight: 500;
  color: #333;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}

.connection-status.online {
  color: #28a745;
}

.connection-status i {
  font-size: 8px;
}

.no-host {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
}

.disconnect-icon {
  font-size: 32px;
  color: #dc3545;
  margin-bottom: 12px;
  opacity: 0.7;
}

.disconnect-text {
  margin: 0 0 8px 0;
  color: #dc3545;
  font-size: 14px;
  font-weight: 500;
}

.reconnect-text {
  margin: 0;
  color: #6c757d;
  font-size: 12px;
}

.mic-off-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  color: #dc3545;
  font-size: 14px;
  font-weight: 500;
}
.mic-off-icon {
  font-size: 18px;
  color: #dc3545;
}
.mic-off-text {
  color: #dc3545;
}
</style>
